module.exports = __webpack_public_path__ + "src/asset/svg/title/contact2.svg?0e0000e471715911a6c082683553c9bb";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/title/contact2.svg
// module id = 97
// module chunks = 0